import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedDocumentsComponent } from './shared-documents/shared-documents.component';
import { MsalGuard } from '@azure/msal-angular';
import { MsalAuthGaurd } from '../sign-in/activate-guad';
const routes: Routes = [
  {path:'documents', component: SharedDocumentsComponent, canActivate:[MsalAuthGaurd] }, 
  { path: '**', redirectTo:'/signin' }  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentsRoutingModule { }
